import { useState, useRef } from 'react';

export const useImageHandling = (addImageLayer, setHasUploadedMap) => {
    const [image, setImage] = useState(null);
    const [scale, setScale] = useState(1);
    const [position, setPosition] = useState({ x: 0, y: 0 });
    const [isDragging, setIsDragging] = useState(false);
    const [dragStart, setDragStart] = useState({ x: 0, y: 0 });
    const [isDragOver, setIsDragOver] = useState(false);
    const [isResizeDragging, setIsResizeDragging] = useState(false);
    const fileInputRef = useRef(null);

    const handleImageUpload = (file, directImage = null) => {
        if (directImage) {
            setImage(directImage);
            addImageLayer(directImage);
            setHasUploadedMap(true);
            return;
        }

        if (!file) return;
        
        const reader = new FileReader();
        reader.onload = (e) => {
            const img = new Image();
            
            img.onload = () => {
                setImage(img);
                addImageLayer(img);
                setHasUploadedMap(true);
            };
            
            img.src = e.target.result;
        };

        reader.readAsDataURL(file);
    };

    const handleDragOver = (e) => {
        e.preventDefault();
        setIsDragOver(true);
    };

    const handleDragLeave = (e) => {
        e.preventDefault();
        setIsDragOver(false);
    };

    const handleDrop = (e) => {
        e.preventDefault();
        setIsDragOver(false);
        const file = e.dataTransfer.files[0];
        if (file && (file.type === "image/png" || file.type === "image/jpeg")) {
            handleImageUpload(file);
        }
    };

    const handleZoom = (direction) => {
        if (!image) return;
        
        const zoomFactor = direction === 'in' ? 1.1 : 0.9;
        const newScale = scale * zoomFactor;
        
        // Limit scale between 0.5 and 3
        if (newScale >= 0.5 && newScale <= 3) {
            setScale(newScale);
        }
    };

    const handleReset = () => {
        if (!image) return;
        setScale(1);
        setPosition({ x: 0, y: 0 });
    };

    const handleImageDragStart = (e) => {
        setIsDragging(true);
        setIsResizeDragging(true);
        setDragStart({ x: e.clientX, y: e.clientY });
    };

    const handleImageDrag = (e) => {
        if (!isDragging) return;
        
        const deltaX = e.clientX - dragStart.x;
        const deltaY = e.clientY - dragStart.y;
        
        setPosition(prev => ({
            x: prev.x + deltaX,
            y: prev.y + deltaY
        }));
        
        setDragStart({ x: e.clientX, y: e.clientY });
    };

    const handleImageDragEnd = () => {
        setIsDragging(false);
        setIsResizeDragging(false);
        setDragStart({ x: 0, y: 0 });
    };

    return {
        image,
        scale,
        position,
        isDragging,
        isDragOver,
        isResizeDragging,
        fileInputRef,
        setImage,
        setScale,
        setPosition,
        handleImageUpload,
        handleDragOver,
        handleDragLeave,
        handleDrop,
        handleZoom,
        handleReset,
        handleImageDragStart,
        handleImageDrag,
        handleImageDragEnd
    };
}; 